import { memo } from 'react'

import { Table, Text, colors } from '@factorialco/deprecated-design-system'
import { ComplianceSnapshotFragment } from 'generated/resources/graphql'

import { dateBackendDateTimeToUI } from 'modules/core/lib/dates'

import {
  mapComplianceSnapshotEventType,
  mapComplianceSnapshotResourceType,
} from 'modules/finance/lib/complianceSnapshotUtils'

const SELECTED_CELL_STYLE = {
  borderLeft: `4px solid ${colors.viridian1000}`,
  paddingLeft: '20px',
}

const DEFAULT_CELL_STYLE = {
  borderLeft: 'none',
  paddingLeft: '24px',
}

export interface ComplianceSnapshotsRowProps {
  complianceSnapshot: ComplianceSnapshotFragment
  selected?: boolean
  onClick?: (complianceSnapshotId: number) => void
}

export const ComplianceSnapshotsRow = memo<ComplianceSnapshotsRowProps>(
  ({ complianceSnapshot, selected, onClick }) => {
    return (
      <Table.Row clickable={!!onClick} onClick={() => onClick?.(complianceSnapshot.id)}>
        <Table.Cell style={selected ? SELECTED_CELL_STYLE : DEFAULT_CELL_STYLE}>
          <Text.Normal size="200" weight="medium" color="grey1000">
            {mapComplianceSnapshotEventType(complianceSnapshot.eventType)}
          </Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <Text.Normal size="200" weight="normal" color="grey1000">
            {mapComplianceSnapshotResourceType(complianceSnapshot.resourceType)}
          </Text.Normal>
        </Table.Cell>
        <Table.Cell>
          <Text.Normal size="200" weight="normal" color="grey1000">
            {dateBackendDateTimeToUI(complianceSnapshot.createdAt)}
          </Text.Normal>
        </Table.Cell>
      </Table.Row>
    )
  }
)

ComplianceSnapshotsRow.displayName = 'ComplianceSnapshotsRow'
